import axios from 'axios';

const customFeatureClient = axios.create();

customFeatureClient.interceptors.request.use(async (config) => {
  if (config.authentication) {
    config.headers = {
      ...config.headers,
      Authorization: `${config.authentication.type} ${config.authentication.value}`,
    };
  }

  return config;
});

customFeatureClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error('Error en la solicitud:', error);
    throw error;
  }
);

export default customFeatureClient;
